"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubNbOperationsDerniersMois = void 0;
exports.ESubNbOperationsDerniersMois = {
    none: "none",
    one_to_five: "one_to_five",
    six_to_ten: "six_to_ten",
    more_then_ten: "more_then_ten",
};
